import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Determine if the app is in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// Keep production console clean: no-op log and warn (error left for critical debugging)
// TEMPORARILY DISABLED for AI generation debugging
// if (!isDevelopment) {
//   const noop = () => {};
//   console.log = noop;
//   console.warn = noop;
// }

// Add error handling for chunk loading
window.addEventListener('error', (event) => {
  if (event.message.includes('Loading chunk') && event.message.includes('failed')) {
    // Force a hard refresh to clear cache and reload chunks
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.name === 'ChunkLoadError') {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  isDevelopment ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);